import React, { useContext, useEffect, useState } from "react";
import { Container } from "reactstrap";
import { useParams } from "react-router-dom";
import styles from "../css/workflow.module.scss";
import { useSelectWorkflowData } from "modules/Library/Workflow/api/useWorkflowQuery";
import CommonTabHeader from "Components/Common/CommonTabHeader";
import FullPageLoader from "Components/Common/FullPageLoader";
import WorkflowPreview from "./WorkflowPreview";
import { Workflow } from "../helpers/workflow.types";
import { BreadcrumbContext } from "Layouts/Header";
import { LIBRARY_PATHS } from "Routes/paths";

/* ----------------------------------
   Component
---------------------------------- */

const ViewWorkflow: React.FC = () => {
  document.title = "View Workflow | ZENTIXS VISTA";
  const [workflow, setWorkflow] = useState<Workflow | null>(null);
  const [workflowName, setWorkflowName] = useState<string>("");
  // Use Param
  const { id } = useParams<{ id: string }>();

  const workflowid = Number(id);

  const { selectQuery } = useSelectWorkflowData(workflowid);
  const { data: selectedWorkflowData } = selectQuery;


  // Breadcrumbs: set for this page
  const breadcrumbContext = useContext(BreadcrumbContext);

  useEffect(() => {
    breadcrumbContext?.setBreadcrumbItems?.([
      { text: "Workflow", link: LIBRARY_PATHS.WORKFLOW_LIST },
      { text: "View Workflow" },
    ]);

    return () => {
      breadcrumbContext?.setBreadcrumbItems?.([]);
    };
  }, [])

  /* ---------- RESET ON ID CHANGE ---------- */
  useEffect(() => {
    setWorkflow(null);
  }, [id]);

  /* ---------- LOAD WORKFLOW ---------- */
  useEffect(() => {
    if (
      selectedWorkflowData?.data !== null &&
      selectedWorkflowData?.data !== undefined
    ) {
      console.log("Workflow Data", selectedWorkflowData?.data);
      setWorkflow(selectedWorkflowData?.data);
      setWorkflowName(selectedWorkflowData?.data?.name);
    }
  }, [selectedWorkflowData]);

  if (selectQuery.isFetching || !workflow) {
    return <FullPageLoader message="Loading Workflow..." />;
  }

  /* ---------- RENDER ---------- */
  return (
    <Container fluid>
      <CommonTabHeader title={workflowName} />

      {/* Workflow Preview */}

      <div className={`row ${styles.workflow_builder} mt-2`}>
        <div className="col-md-12">
          <WorkflowPreview
            stages={workflow.stages}
            onEditStage={() => {}}
            onAddStage={() => {}}
            onDeleteStage={() => {}}
            setStages={() => {}}
            readOnly={true} // ✅ IMPORTANT
          />
        </div>
      </div>
    </Container>
  );
};

export default ViewWorkflow;
